import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { AggReqObjectHandlerService } from 'src/app/_services/agg-req-object-handler.service';
import { AggregationService } from 'src/app/_services/aggregation.service';
import { FilterDataHandlerService } from 'src/app/_services/filter-data-handler.service';
import { LocalStorageService } from 'src/app/_services/local-storage.service';
import { PersonSearchService } from 'src/app/_services/person-search.service';
import { TalentInsightsReqHandlerService } from 'src/app/_services/talent-insights-req-handler.service';
import { GeneralConstants } from 'src/app/constants/GeneralConstants';

import * as _ from "underscore";

@Component({
  selector: 'app-report-details',
  templateUrl: './report-details.component.html',
  styleUrls: ['./report-details.component.scss']
})
export class ReportDetailsComponent implements OnInit, OnDestroy {
  talentfilterdata: any
  totalcount: any

  subscriptions: Array<Subscription> = [];

  constructor(private route: ActivatedRoute, private personsearchservice: PersonSearchService, private router: Router, 
    private localstorageservice: LocalStorageService, private filterDataHandlerService: FilterDataHandlerService,
    private aggService: AggregationService, private talentInsightsReqHandlerService: TalentInsightsReqHandlerService,
    private aggReqObjectHandlerService: AggReqObjectHandlerService) { }

  ngOnInit(): void {
    this.talentfilterdata = JSON.parse(this.localstorageservice.getItem('talentfilters') || "{}");
    const filterData = JSON.parse(this.localstorageservice.getItem(GeneralConstants.LS_KEYS.TALENT_FILTERS));    
    if (!filterData || _.isEmpty(filterData)) {
      this.filterDataHandlerService.reset();
    } else {
      this.filterDataHandlerService.setFilterData(filterData);
    }
    this.personsearchservice.setTalentinsightsFilterAI(this.talentfilterdata)

    this.talentfilterdata['company'] = this.talentfilterdata.company ? this.talentfilterdata.company : [];
    this.talentfilterdata['industry'] = this.talentfilterdata.industry ? this.talentfilterdata.industry : [];
    this.talentfilterdata['function'] = this.talentfilterdata.function ? this.talentfilterdata.function : [];
    this.talentfilterdata['school'] = this.talentfilterdata.school ? this.talentfilterdata.school : [];
    this.talentfilterdata['degree'] = this.talentfilterdata.degree ? this.talentfilterdata.degree : [];
    this.talentfilterdata['keyword'] = this.talentfilterdata.keyword ? this.talentfilterdata.keyword : [];
    this.talentfilterdata['fromyearsofexperience'] = this.talentfilterdata.fromyearsofexperience ? this.talentfilterdata.fromyearsofexperience : null;
    this.talentfilterdata['toyearsofexperience'] = this.talentfilterdata.toyearsofexperience ? this.talentfilterdata.toyearsofexperience : null;
    this.getprofessionalcount();
 //   const tab = this.router.url.split('/')[2];

    //this.redirecttotab(tab)
     this.personsearchservice.setTalentinsights(this.talentfilterdata);
    // const tab = this.router.url.split('/')[2];
    // this.router.navigate([`/report-details/${tab}`], {state: this.talentfilterdata, skipLocationChange: false})
    // const recCandidateDataEvent = this.aggService.recCandidateDataEvent.subscribe(response => this.totalcount = response.totalresultscount);
    // this.subscriptions.push(recCandidateDataEvent);
    const filterMethodExecEvent = this.filterDataHandlerService.filterMethodEvent.subscribe(_data => this.getprofessionalcount());
    this.subscriptions.push(filterMethodExecEvent);
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  /**
   * 
   * TODO : This method can be replaced with another private utility method which will be called whenever a filter operation is emitted.
   * 
   */
  getfiltesdata(data) {
    this.talentfilterdata['jobtitle'] = data.jobtitle;
    this.talentfilterdata['company'] = data.company;
    this.talentfilterdata['industry'] = data.industry;
    this.talentfilterdata['function'] = data.function;
    this.talentfilterdata['school'] = data.school;
    this.talentfilterdata['degree'] = data.degree;
    this.talentfilterdata['keyword'] = data.keyword;
    this.talentfilterdata['fromyearsofexperience'] = data.fromyearsofexperience;
    this.talentfilterdata['toyearsofexperience'] = data.toyearsofexperience;
    this.talentfilterdata['location'] = data.location;
    this.talentfilterdata['skills'] = data.skills;
    this.talentfilterdata['filterselected'] = 'yes';
    // TODO : Capture event emission here as well.
    this.localstorageservice.setItem('talentfilters', JSON.stringify(this.talentfilterdata));
    // this.getprofessionalcount();


   this.personsearchservice.setTalentinsights(this.talentfilterdata);
//    const NavigationExtras :NavigationExtras ={
//     state: this.talentfilterdata,
//   }  
//  // window.location.reload();
    const tab = this.router.url.split('/')[2];
     this.router.onSameUrlNavigation = 'reload';
     this.router.navigate([`/report-details/${tab}`], {state: this.talentfilterdata, skipLocationChange: true})
    // this.router.navigateByUrl('/', { skipLocationChange: true }).then(() =>
    // this.router.navigate([location.pathname]));
  }

  redirecttotab(type) {

    this.router.navigate([`/report-details/${type}`],{replaceUrl: true })

  }

  getprofessionalcount() {
    let aggReq = this.talentInsightsReqHandlerService.talentInsightRequest;
    aggReq.aggregatetype = this.talentfilterdata && this.talentfilterdata['skills'].length > 0 ? 'skills': 'current_jobtitle';
    aggReq.startindex = 0;
    aggReq.resultsize = 5;
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
    aggReq = this.aggService.getRequestWithFilters();
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
  
    this.personsearchservice.getTotalAggs(aggReq).subscribe(res => {
      if(res && res.data){
        this.totalcount = res.data.totalresultscount;
      }
    })
  }

  formatNumberToIndianFormat(number) {
    if (number) {
      const suffixes = ['', 'K+', 'M+', 'B+', 'T+']; // Add more suffixes as needed for larger numbers
      for (const suffix of suffixes) {
        if (Math.abs(number) < 1000) {
          return Math.floor(number) + suffix;
        }
        number /= 1000;
      }
      return Math.floor(number) + 'T';
    } else {
      return 0
    }
  }

}
